import React from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import "@/App.css";

import { LangProvider } from "@/lib/i18n";
import { Toaster } from "@/components/ui/sonner";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import CookieBanner from "@/components/CookieBanner";
import { GA_ID } from "@/lib/analytics";

import Home from "@/pages/Home";
import ServicePage from "@/pages/ServicePage";
import LocationPage from "@/pages/LocationPage";
import WaszBase from "@/pages/WaszBase";
import About from "@/pages/OverOns";
import Contact from "@/pages/Contact";
import FAQPage from "@/pages/FAQ";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import Admin from "@/pages/Admin";
import NotFound from "@/pages/NotFound";
import Privacy from "@/pages/Privacy";
import Cookies from "@/pages/Cookies";
import MobieleTruckwashSEO from "@/pages/MobieleTruckwashSEO";
import Story from "@/pages/Story";
import CaseDemoNaarDigitaleControle from "@/pages/CaseDemoNaarDigitaleControle";
import LocationPageExtra from "@/pages/LocationPageExtra";
import MobieleTruckwashNederland from "@/pages/MobieleTruckwashNederland";
import Wagenparkreiniging from "@/pages/Wagenparkreiniging";
import DigitaleWagenparkadministratie from "@/pages/DigitaleWagenparkadministratie";
import ReinigingsregistratieTransport from "@/pages/ReinigingsregistratieTransport";
import CertificaatbeheerWagenpark from "@/pages/CertificaatbeheerWagenpark";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
  return null;
};

// Send a virtual pageview to GA on every SPA route change (only when consent granted).
const AnalyticsRouteTracker = () => {
  const { pathname, search } = useLocation();
  useEffect(() => {
    if (typeof window === "undefined" || typeof window.gtag !== "function") return;
    window.gtag("event", "page_view", {
      page_path: pathname + search,
      page_location: window.location.href,
      page_title: document.title,
      send_to: GA_ID,
    });
  }, [pathname, search]);
  return null;
};

const Shell = () => (
  <>
    <ScrollToTop />
    <AnalyticsRouteTracker />
    <Header />
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/mobiele-truckwash" element={<MobieleTruckwashSEO />} />
      <Route path="/mobiele-truckwash/" element={<MobieleTruckwashSEO />} />
      <Route path="/het-verhaal-achter-wasz" element={<Story />} />
      <Route path="/het-verhaal-achter-wasz/" element={<Story />} />
      <Route path="/van-demo-tot-digitale-wagenparkcontrole" element={<CaseDemoNaarDigitaleControle />} />
      <Route path="/van-demo-tot-digitale-wagenparkcontrole/" element={<CaseDemoNaarDigitaleControle />} />
      <Route path="/vrachtwagenreiniging" element={<ServicePage />} />
      <Route path="/fleet-cleaning" element={<ServicePage />} />
      <Route path="/wagenpark-reiniging" element={<ServicePage />} />
      <Route path="/haccp-certificaten" element={<ServicePage />} />
      <Route path="/waszbase" element={<WaszBase />} />
      <Route path="/over-ons" element={<About />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/faq" element={<FAQPage />} />
      <Route path="/blog" element={<Blog />} />
      <Route path="/blog/:slug" element={<BlogPost />} />
      <Route path="/kennisbank/:slug" element={<BlogPost />} />
      <Route path="/truckwash-almere" element={<LocationPage />} />
      <Route path="/truckwash-amsterdam" element={<LocationPage />} />
      <Route path="/truckwash-den-haag" element={<LocationPage />} />
      <Route path="/truckwash-rotterdam" element={<LocationPage />} />
      <Route path="/truckwash-utrecht" element={<LocationPage />} />
      <Route path="/truckwash-waddinxveen" element={<LocationPageExtra />} />
      <Route path="/truckwash-alphen-aan-den-rijn" element={<LocationPageExtra />} />
      <Route path="/truckwash-alkmaar" element={<LocationPageExtra />} />
      <Route path="/truckwash-barneveld" element={<LocationPageExtra />} />
      <Route path="/truckwash-breda" element={<LocationPageExtra />} />
      <Route path="/truckwash-amersfoort" element={<LocationPageExtra />} />
      <Route path="/truckwash-zeewolde" element={<LocationPageExtra />} />

      {/* SEO landing pages */}
      <Route path="/mobiele-truckwash-nederland" element={<MobieleTruckwashNederland />} />
      <Route path="/wagenparkreiniging" element={<Wagenparkreiniging />} />
      <Route path="/digitale-wagenparkadministratie" element={<DigitaleWagenparkadministratie />} />
      <Route path="/reinigingsregistratie-transport" element={<ReinigingsregistratieTransport />} />
      <Route path="/certificaatbeheer-wagenpark" element={<CertificaatbeheerWagenpark />} />
      <Route path="/admin" element={<Admin />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/cookies" element={<Cookies />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
    <Footer />
    <CookieBanner />
    <Toaster theme="dark" position="top-right" richColors />
  </>
);

// Service page param helper - read slug from path
// We use route pattern that maps each direct path to the same ServicePage component;
// inside ServicePage we read slug from useParams or location pathname.

function App() {
  return (
    <div className="App min-h-screen bg-[#050509] text-white">
      <LangProvider>
        <BrowserRouter>
          <Shell />
        </BrowserRouter>
      </LangProvider>
    </div>
  );
}

export default App;
